import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getGroup, saveGroupByAccount, updateGroup } from './GroupService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Checkbox, FormControlLabel } from '@mui/material';

import GroupUserList from './GroupUserList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

// import AccountUserList from './AccountUserList';
// import AccountAppList from './AccountAppList';
// import GroupList from '../groups/GroupList';

const GroupDetail = (): JSX.Element => {
  const [groupName, setGroupName] = useState('');
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { accountid } = useParams();
  const { groupid } = useParams();

  function clearGroupDetailsForm() {
    setGroupName('');
    setVisible(false);
    // setStartDate('')
    // setEndDate('')
    // setEnabled('')
  }

  const cancelSaveOrUpdateGroup = () => {
    clearGroupDetailsForm();
    // navigate(`/system/account/{accountid}`)
    navigate(`/system/dashboard/account/${accountid}`);
  };

  function saveOrUpdateGroup(e) {
    e.preventDefault();

    const group = { groupName, status };

    if (groupid) {
      updateGroup(groupid, group)
        .then(() => {
          // navigate('/system/account/{accountid}')
          navigate(`/system/dashboard/account/${accountid}`);
          // `${REST_API_BASE_URL}/subscription/${id}`
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveGroupByAccount(accountid, group)
        .then(() => {
          navigate(`/system/dashboard/account/${accountid}`);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  // function pageTitle() {
  //   if (groupid) {
  //     return <h2 className="text-center">Pause & Plan</h2>;
  //   } else {
  //     <h2 className="text-center">Add Group</h2>;
  //   }
  // }

  useEffect(() => {
    if (groupid) {
      console.log('groupid exists: ', groupid);
      getGroup(groupid)
        .then((response) => {
          console.log(response.data);
          setGroupName(response.data.groupName);
          setVisible(response.data.visible);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [groupid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={`/system/dashboard/account/${accountid}`}
            >
              Account Detail
            </Link>
            <Typography color="text.primary">Group Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Group Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Group Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'groupName'}
                  fullWidth
                  value={groupName} // Use the 'sequence' state variable as the value
                  onChange={(event) => setGroupName(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Visible?
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={visible} // Use the 'enabled' state variable as the checked value
                      onChange={(event) => setVisible(event.target.checked)} // Update the 'enabled' state variable on change
                      name="visible" // Name for the checkbox (optional)
                    />
                  }
                  label="Visible?"
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateGroup}>Cancel</Button>
                  <Button onClick={saveOrUpdateGroup}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box>
          <GroupUserList />
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default GroupDetail;
